import styled from "styled-components";
import { WhitePage } from "@style/whitePage";
import { ErrorMessageStyle } from "@components/errorMessage/errorMessageStyle";

export const TrucksPageStyle = styled(WhitePage)`
    ${ErrorMessageStyle} {
        margin-bottom: 25px;
    }
`;
